import Header from "components/Headers/Header";
import TabsComponent from "components/TabsComponent";
import moment from "moment";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { sendEmailToFanNotification } from "store/actions/notificationAction";
import { markNotificationAsRead } from "store/actions/notificationAction";
import { getReadNotification } from "store/actions/notificationAction";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Spinner,
} from "reactstrap";

const Notifications = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  let auth = useSelector((state) => state.auth);
  const { unreadNotifications, readNotifications } = useSelector(
    (state) => state.notification
  );
  const [activeTab, setActiveTab] = useState("Unread");
  const [isLoading, setIsLoading] = useState(false);

  const handleReadNotification = () => {
    setIsLoading(true);
    dispatch(
      getReadNotification(auth.user?.id, () => {
        setIsLoading(false);
      })
    );
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const handleNotificationCard = (item) => {
    dispatch(
      markNotificationAsRead(item.id, auth.user?.id, () => {
        if (item.type === "contest") {
          history.push(`/admin/athlete-contest`);
        } else if (item.message) {
          history.push(`/admin/sports-community-badge`);
        }
      })
    );
  };

  const sendEmail = (obj) => {
    let payload = {
      fanEmail: obj.fanEmail,
      id: obj.id,
    };
    dispatch(sendEmailToFanNotification(payload));
  };

  const tabs = [
    {
      id: "Unread",
      title: "Unread",
      content: (
        <>
          {isLoading ? (
            <div className="text-center" role="status">
              <Spinner size="sm" />
            </div>
          ) : unreadNotifications?.length > 0 ? (
            unreadNotifications.map((item) =>
              item.type === "contest" ? (
                <Card
                  className="mb-3"
                  key={item.id}
                  onClick={() => {
                    handleNotificationCard(item);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <CardBody>
                    <Row>
                      <Col>
                        <p className="mb-1 fw-bold">
                          {`${auth.user.institute_name} has participated in the Contest. See Now.`}
                        </p>
                        <p
                          className="mb-0 text-muted"
                          style={{ fontSize: "0.85rem" }}
                        >
                          {moment(item?.createdAt?.toDate?.()).fromNow()}
                        </p>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              ) : item.type === "Endorsement" ? (
                <Card
                  className="mb-3"
                  key={item.id}
                  onClick={() => {
                    handleNotificationCard(item);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <CardBody>
                    <Row className=" d-flex justify-content-around align-items-center">
                      <Col>
                        <p className="mb-1 fw-bold">
                          A Sports Fan named {item.fanName} just bought an
                          {item.type && " Endorsement"} badge from you.Would you
                          like to send this Fan an email telling Fan you are
                          ready to chat with him or her? Button below sends that
                          email.You can also check the Question Database on your
                          Chat Home Page to see if this Fan has already posted a
                          question you wish to answer.If yes, you can click one
                          of the 'arrange chat' buttons on Chat Home page to set
                          up Chat.
                        </p>
                        <p
                          className="mb-0 text-muted"
                          style={{ fontSize: "0.85rem" }}
                        >
                          {moment(item?.createdAt?.toDate?.()).fromNow()}
                        </p>
                      </Col>
                      <Col>
                        <div className="text-right">
                          <Button
                            color="primary my-3 notification_button"
                            onClick={() => sendEmail(item)}
                          >
                            Send Email to Fan who Bought my badge
                          </Button>
                        </div>
                      </Col>
                    </Row>
                    <h3 className="text-center my-2"></h3>
                  </CardBody>
                </Card>
              ) : (
                <Card
                  className="mb-3"
                  key={item.id}
                  onClick={() => {
                    handleNotificationCard(item);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <CardBody>
                    <Row className="mb-3">
                      <Col>
                        <p className="mb-1 fw-bold">
                          {`Admin sends a message : ${item.message} `}
                        </p>
                        <p
                          className="mb-0 text-muted"
                          style={{ fontSize: "0.85rem" }}
                        >
                          {moment(item?.createdAt?.toDate?.()).fromNow()}
                        </p>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              )
            )
          ) : (
            <p className="text-center text-muted mt-3">
              No Unread Notifications.
            </p>
          )}
        </>
      ),
      onClick: () => {},
    },
    {
      id: "Read",
      title: "Read",
      content: (
        <>
          {isLoading ? (
            <div className="text-center" role="status">
              <Spinner size="sm" />
            </div>
          ) : readNotifications?.length > 0 ? (
            readNotifications.map((item) =>
              item.type === "contest" ? (
                <Card className="mb-3" key={item.id}>
                  <CardBody>
                    <Row>
                      <Col>
                        <p className="mb-1 fw-bold">
                          {`${auth.user.institute_name} has participated in the Contest. See Now.`}
                        </p>
                        <p
                          className="mb-0 text-muted"
                          style={{ fontSize: "0.85rem" }}
                        >
                          {moment(item?.createdAt?.toDate?.()).fromNow()}
                        </p>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              ) : item.type === "Endorsement" ? (
                <Card className="mb-3" key={item.id}>
                  <CardBody>
                    <Row className=" d-flex justify-content-around align-items-center">
                      <Col>
                        <p className="mb-1 fw-bold">
                          A Sports Fan named {item.fanName} just bought an
                          {item.type && " Endorsement"} badge from you.Would you
                          like to send this Fan an email telling Fan you are
                          ready to chat with him or her? Button below sends that
                          email.You can also check the Question Database on your
                          Chat Home Page to see if this Fan has already posted a
                          question you wish to answer.If yes, you can click one
                          of the 'arrange chat' buttons on Chat Home page to set
                          up Chat.
                        </p>
                        <p
                          className="mb-0 text-muted"
                          style={{ fontSize: "0.85rem" }}
                        >
                          {moment(item?.createdAt?.toDate?.()).fromNow()}
                        </p>
                      </Col>
                      <Col>
                        <div className="text-right">
                          <Button
                            color="primary my-3 notification_button"
                            onClick={() => sendEmail(item)}
                          >
                            Send Email to Fan who Bought my badge
                          </Button>
                        </div>
                      </Col>
                    </Row>
                    <h3 className="text-center my-2"></h3>
                  </CardBody>
                </Card>
              ) : (
                <Card className="mb-3" key={item.id}>
                  <CardBody>
                    <Row>
                      <Col>
                        <p className="mb-1 fw-bold">
                          {`Admin sends a message : ${item.message} `}
                        </p>
                        <p
                          className="mb-0 text-muted"
                          style={{ fontSize: "0.85rem" }}
                        >
                          {moment(item?.createdAt?.toDate?.()).fromNow()}
                        </p>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              )
            )
          ) : (
            <p className="text-center text-muted mt-3">
              No Read Notifications.
            </p>
          )}
        </>
      ),
      onClick: () => {
        handleReadNotification();
      },
    },
  ];

  return (
    <>
      <Header />
      <Container fluid>
        <h2>Notification</h2>
        <Row>
          <div className="col">
            <Card className="shadow">
              <TabsComponent
                activeTab={activeTab}
                toggleTab={toggleTab}
                tabs={tabs}
              />
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Notifications;
